import { Box, Modal, Grid } from "@mui/material";
import React from "react";
interface UserModalProps {
  open: boolean;
  isEdit?: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  user?: any;
  setUser?: any;
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
  width: "100%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "10px",
};
const TeamModal = ({
  open,
  onClose,
  isEdit = false,
  onSubmit,
  user,
  setUser,
}: UserModalProps) => {
  const changeHandler = (e: any) => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    const regPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\./0-9]*$/;
    if (name === "phone") {
      if(value && regPhone.test(value)){
        setUser((pre: any) => ({
          ...pre,
          [name]: value,
        }));
      }
    } else {
      setUser((pre: any) => ({
        ...pre,
        [name]: value,
      }));
    }
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <div className={"text-2xl font-bold"}>
          {isEdit ? "Update" : "Create"} User Modal
        </div>
        <form
          onSubmit={() => {
            if (onSubmit && onClose) {
              onSubmit();
              onClose();
            }
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={isEdit ? 6 : 4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"first_name"}
                  className={"text-sm font-semibold"}
                >
                  First Name
                </label>
                <input
                  id={"first_name"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"first_name"}
                  value={user?.first_name}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            {!isEdit && (
              <Grid item xs={4}>
                <div className={"w-full flex flex-col items-start"}>
                  <label
                    htmlFor={"middle_name"}
                    className={"text-sm font-semibold"}
                  >
                    Middle Name
                  </label>
                  <input
                    id={"middle_name"}
                    className={
                      "bg-white w-full rounded-md p-2 border border-gray outline-none"
                    }
                    type={"text"}
                    name={"middle_name"}
                    value={user?.middle_name}
                    onChange={changeHandler}
                    required
                  />
                </div>
              </Grid>
            )}
            <Grid item xs={isEdit ? 6 : 4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"last_name"}
                  className={"text-sm font-semibold"}
                >
                  Last Name
                </label>
                <input
                  id={"last_name"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"last_name"}
                  value={user?.last_name}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"email"} className={"text-sm font-semibold"}>
                  Email
                </label>
                <input
                  id={"email"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"email"}
                  value={user?.email}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"phone"} className={"text-sm font-semibold"}>
                  Phone
                </label>
                <input
                  id={"phone"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"phone"}
                  value={user?.phone}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={isEdit ? 12 : 6}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"password"} className={"text-sm font-semibold"}>
                  Password
                </label>
                <input
                  id={"password"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"password"}
                  name={"password"}
                  value={user?.password}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            {!isEdit && (
              <Grid item xs={6}>
                <div className={"w-full flex flex-col items-start"}>
                  <label
                    htmlFor={"user_type"}
                    className={"text-sm font-semibold"}
                  >
                    User Type
                  </label>
                  <select
                    className={
                      "bg-white w-full rounded-md p-2 border border-gray outline-none"
                    }
                    name={"user_type"}
                    value={user?.user_type}
                    onChange={changeHandler}
                    required
                    defaultValue={"system_admin"}
                  >
                    <option value={"support"}>Support</option>
                    <option value={"system_admin"}>System Admin</option>
                  </select>
                </div>
              </Grid>
            )}
            <Grid item xs={12}>
              <button
                className={
                  "bg-primary text-white p-3 rounded-lg disabled:cursor-not-allowed w-full"
                }
                type={"submit"}
              >
                {isEdit ? "Update" : "Create"}
              </button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};
export default TeamModal;
